import script from "./kelas.vue?vue&type=script&setup=true&lang=ts"
export * from "./kelas.vue?vue&type=script&setup=true&lang=ts"

import "~/pages/_workflow.css?vue&type=style&index=0&id=6d4839b4&scoped=true&lang=css&external"
import "./kelas.vue?vue&type=style&index=1&id=6d4839b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4839b4"]])

export default __exports__